/* eslint-disable no-param-reassign,no-plusplus,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';
import { getDataForSchemaImporter } from '../../../../app/package-designer/helpers/schema.helpers';
import { COMPONENT_TYPE } from '../../../../app/constants/component_type';

xplenty.directive('analyticsSourceEditor', [
  '$timeout',
  '$rootScope',
  'ConnectionItemsResource',
  function ($timeout, $rootScope, ConnectionItemsResource) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./analytics-source-editor.html'),

      replace: true,

      scope: false,

      controller: [
        '$scope',
        '$http',
        '$stateParams',
        function ($scope, $http, $stateParams) {
          $scope.dataRangeOptions = [
            {
              text: 'Today',
              min: 'today',
              max: 'today',
              value: 'TODAY',
            },
            {
              text: 'Yesterday',
              min: 'yesterday',
              max: 'yesterday',
              value: 'YESTERDAY',
            },
            {
              text: 'Last 3 days',
              min: '3daysAgo',
              max: 'today',
              value: 'LAST_3_DAYS',
            },
            {
              text: 'Last 7 days',
              min: '7daysAgo',
              max: 'today',
              value: 'LAST_7_DAYS',
            },
            {
              text: 'Last 14 days',
              min: '14daysAgo',
              max: 'today',
              value: 'LAST_14_DAYS',
            },
            {
              text: 'Last 30 days',
              min: '30daysAgo',
              max: 'today',
              value: 'LAST_30_DAYS',
            },
            {
              text: 'All time',
              min: '2005-01-01',
              max: 'today',
              value: 'ALL_TIME',
            },
            {
              text: 'Custom date range...',
              min: '',
              max: '',
              value: 'CUSTOM_DATE',
            },
          ];

          $scope.segmentOptions = [
            {
              label: 'All Visits',
              value: 'gaid::-1',
            },
            {
              label: 'New Visitors',
              value: 'gaid::-2',
            },
            {
              label: 'Returning Visitors',
              value: 'gaid::-3',
            },
            {
              label: 'Paid Search Traffic',
              value: 'gaid::-4',
            },
            {
              label: 'Non-paid Search Traffic',
              value: 'gaid::-5',
            },
            {
              label: 'Search Traffic',
              value: 'gaid::-6',
            },
            {
              label: 'Direct Traffic',
              value: 'gaid::-7',
            },
            {
              label: 'Referral Traffic',
              value: 'gaid::-8',
            },
            {
              label: 'Visits with Conversions',
              value: 'gaid::-9',
            },
            {
              label: 'Visits with Transactions',
              value: 'gaid::-10',
            },
            {
              label: 'Mobile and Tablet Traffic',
              value: 'gaid::-11',
            },
            {
              label: 'Non-bounce Visits',
              value: 'gaid::-12',
            },
            {
              label: 'Tablet traffic',
              value: 'gaid::-13',
            },
            {
              label: 'Mobile Traffic',
              value: 'gaid::-14',
            },
          ];

          $scope.onReportDateRangeTypeChange = function (reportDateRangeType) {
            $scope.component.report_date_range_type = reportDateRangeType;
          };

          $scope.onProfileIdsChange = function (profileIds) {
            $scope.component.profile_ids = profileIds;
          };

          $scope.reportSamplingLevelOptions = [
            { value: 'DEFAULT', text: 'Default' },
            { value: 'FASTER', text: 'Small' },
            { value: 'HIGHER_PRECISION', text: 'Large' },
          ];

          $scope.onReportSamplingLevelChange = function (reportSampingLevel) {
            $scope.component.report_sampling_level = reportSampingLevel;
          };

          $scope.formatTypeahead = function (array, value) {
            const o = _.find(array, { value });
            return o ? o.label || value : value;
          };

          $scope.component.report_date_range_type = (function () {
            let dateRange = _.find($scope.dataRangeOptions, {
              min: $scope.component.report_date_range_min,
              max: $scope.component.report_date_range_max,
            });
            if (!dateRange) {
              dateRange = {
                value: 'CUSTOM_DATE',
              };
            }
            return dateRange.value;
          })();

          $scope.$watch('component.report_date_range_type', function (newRangeType, oldRangeType) {
            if (newRangeType !== 'CUSTOM_DATE') {
              const dateRange = _.find($scope.dataRangeOptions, { value: newRangeType });
              if (dateRange) {
                $scope.component.report_date_range_min = dateRange.min;
                $scope.component.report_date_range_max = dateRange.max;
                $rootScope.use_custom_date_range = false;
              } else {
                $rootScope.use_custom_date_range = true;
              }
            }

            if (oldRangeType !== newRangeType && newRangeType === 'CUSTOM_DATE') {
              $scope.component.report_date_range_min = '';
              $scope.component.report_date_range_max = '';
              $rootScope.use_custom_date_range = true;
            }
          });

          $scope.$on('destroy', function () {
            delete $rootScope.use_custom_date_range;
          });

          const categoryMap = {
            DIMENSION: 'Dimensions',
            METRIC: 'Metrics',
          };

          $.get('https://www.googleapis.com/analytics/v3/metadata/ga/columns?pp=1', function (data) {
            const availableFields = [];
            _.each(data.items, function (analyticsItem) {
              if (analyticsItem.attributes.status === 'PUBLIC') {
                if (
                  angular.isUndefined(analyticsItem.attributes.minTemplateIndex) &&
                  angular.isUndefined(analyticsItem.attributes.premiumMinTemplateIndex)
                ) {
                  availableFields.push({
                    name: analyticsItem.id,
                    alias: analyticsItem.id.replace(':', '_'),
                    data_type: 'string', // analyticsItem.attributes.dataType
                    category: categoryMap[analyticsItem.attributes.type],
                  });
                } else {
                  let index =
                    analyticsItem.attributes.premiumMinTemplateIndex || analyticsItem.attributes.minTemplateIndex;
                  const end =
                    analyticsItem.attributes.premiumMaxTemplateIndex || analyticsItem.attributes.maxTemplateIndex;
                  while (index <= end) {
                    availableFields.push({
                      name: analyticsItem.id.replace('XX', index),
                      alias: analyticsItem.id.replace('XX', index).replace(':', '_'),
                      data_type: 'string', // analyticsItem.attributes.dataType
                      category: categoryMap[analyticsItem.attributes.type],
                    });
                    index++;
                  }
                }
              }
            });

            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_SET_AVAILABLE_FIELDS, availableFields);
            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADED);
            $scope.availableFields = availableFields;
          });

          $scope.$on(EVENTS.SCHEMA_IMPORTER_CHANGED, function (event, selectedFields) {
            $scope.component.metrics = _.map(_.filter(selectedFields, { _category: categoryMap.METRIC }), 'name');
            $scope.component.dimensions = _.map(_.filter(selectedFields, { _category: categoryMap.DIMENSION }), 'name');
          });

          $scope.$on(EVENTS.DATA_PREVIEW_REFRESH, function () {
            const schemaRequestData = getDataForSchemaImporter(
              $scope.component,
              COMPONENT_TYPE.ANALYTICS_SOURCE_COMPONENT,
              $stateParams.account_id,
            );

            if ($scope.component.connection.type) {
              ConnectionItemsResource.schema(
                $scope.component.connection.type,
                $scope.component.connection.id,
                schemaRequestData,
              ).subscribe(
                function (data) {
                  $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADED, data);
                },
                function (res) {
                  $rootScope.$broadcast(EVENTS.DATA_PREVIEW_ERROR, res.error.error_message);
                },
              );
            }
          });
        },
      ],
    };
  },
]);
